var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('affix',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.scrollSpy),expression:"scrollSpy"}],attrs:{"offset":60}},[_c('ul',{staticClass:"nav bs-docs-sidenav",attrs:{"id":"sidenav"}},_vm._l((_vm.sections),function(s){return _c('li',{class:{active:_vm.active==s.id}},[_c('a',{staticClass:"handCursor",on:{"click":function($event){_vm.scrollMeTo(s.id)}}},[_vm._v(_vm._s(s.name))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e14f8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/affixSidebar.vue
// module id = 427
// module chunks = 0